<template>
    <div class="time-bar-new" v-bind:class="{shift: eventProp.isShift, fixed: !eventProp.relative, 'override-contract': overrideContract}">
        <div class="hour-grid" v-bind:class="{full: parseInt(timeDisplayLengthInMilliseconds / (1000 * 60 * 60)) === 24, 'full-half': parseInt(timeDisplayLengthInMilliseconds / (1000 * 60 * 60)) === 36, half: parseInt(timeDisplayLengthInMilliseconds / (1000 * 60 * 60)) === 12 ,quarter: parseInt(timeDisplayLengthInMilliseconds / (1000 * 60 * 60)) === 6}" v-if="true">
            <div class="time-marks">
                <div class="mark" v-for="indexHour in parseInt(timeDisplayLengthInMilliseconds / (1000 * 60 * 60))" v-bind:class="{am: parseInt(day.clone().add(indexHour, 'hours').format('HH')) < 13}" :key="indexHour">
                    <div class="label">{{indexHour + day.hour() < 11 ? '0' + (indexHour + day.hour()  - 1).toString() : indexHour + day.hour()  === 25 ? '00' : (indexHour + day.hour()  - 1)}}</div>
                </div>
            </div>
        </div>
        <div class="background tomorrow" v-bind:style="GetOffsetTomorrow()"></div>
        <div class="background yesterday" v-bind:style="GetOffsetYesterday()"></div>
        <div class="background" v-if="!eventProp.hideBar">
            <div v-for="(timeFrame, index) in timeFrames" v-bind:id="index" v-if="timeFrame.approved || timeFrame.approved === undefined" v-on:click="ToggleDropDownShift($event, GetShiftOptions(timeFrame), 0, 10)" v-bind:style="GetOffset(timeFrame)" v-bind:class="[timeFrame.classes, {selected: shiftsSelected.find(s => s === timeFrame.shift)}, {locked: (timeFrame.classes.indexOf('historic') !== -1 && parseInt(timeFrame.shift.historicFromDate.format('x')) < parseInt(currentDate.format('x'))), 'locked-start': timeFrame.startDate.date() !== day.date()},{'template' : timeFrame.shift && timeFrame.shift.weekDays},{'published': timeFrame.shift && timeFrame.shift.published}]" class="timeframe" :key="'frame' + index" v-on:mousedown="DragStartShift($event, timeFrame.shift)" drag>
                <div class="overtime start"></div>
                <div class="overtime end"></div>
                <div class="label start" v-if="!missingShiftStart">{{timeFrame.startDate.format('HH') + ':' + timeFrame.startDate.format('mm')}}</div>
                <div class="label end" v-if="!missingShiftEnd">{{timeFrame.endDate.format('HH') + ':' + timeFrame.endDate.format('mm')}}</div>
                <div class="handle start" v-on:mousedown="StartDrag($event, timeFrame, index, 'start')" v-if="timeFrame.editable">&vert;</div>
                <div class="handle end" v-on:mousedown="StartDrag($event, timeFrame, index, 'end')" v-if="timeFrame.editable">&vert;</div>
            </div>
            <!-- <div v-for="(timeFrame, indexCopy) in timeFramesCopy" v-bind:id="indexCopy" v-if="timeFrame.approved || timeFrame.approved === undefined" v-on:click="ToggleDropDownShift($event, GetShiftOptions(timeFrame), 0, 10)" v-bind:style="GetOffset(timeFrame)" v-bind:class="[timeFrame.classes, {selected: shiftsSelected.find(s => s === timeFrame.shift)}]" class="timeframe" :key="'frame' + indexCopy" v-on:mousedown="DragStartShift($event, timeFrame.shift)" drag>
                <div class="overtime start"></div>
                <div class="overtime end"></div>
                <div class="label start" v-if="!missingShiftStart">{{timeFrame.startDate.format('HH') + ':' + timeFrame.startDate.format('mm')}}</div>
                <div class="label end" v-if="!missingShiftEnd">{{timeFrame.endDate.format('HH') + ':' + timeFrame.endDate.format('mm')}}</div>
                <div class="handle start" v-on:mousedown="StartDrag($event, timeFrame, indexCopy, 'start')" v-if="timeFrame.editable">&vert;</div>
                <div class="handle end" v-on:mousedown="StartDrag($event, timeFrame, indexCopy, 'end')" v-if="timeFrame.editable">&vert;</div>
            </div> -->
        </div>
        <div class="info">
            <div class="entry" v-for="(entry, i) in info" :key="'entry-'+i" v-bind:class="{half: entry.half}">
                <div class="label">{{entry.label}}</div>
                <div class="data">{{entry.data}}</div>
            </div>
            <div class="entry warning" v-for="(entry, iw) in warnings" :key="'warning-'+iw" v-bind:class="{half: entry.half}">
                <div class="label">{{entry.label}}</div>
                <div class="data">{{entry.data}}</div>
            </div>
            <div class="entry error" v-for="(entry, ie) in errors" :key="'error-'+ie" v-bind:class="{half: entry.half}">
                <div class="label">{{entry.label}}</div>
                <div class="data">{{entry.data}}</div>
            </div>
            <div class="employee" v-if="false">
                <div class="picture" v-bind:style="{ background: (employee !== null ? employee.picture : 'url(../img/default.jpg)')}"></div>
                <div class="namefirst">{{employee.firstName}}</div>
                <div class="namelast">{{employee.lastName}}</div>

                <div class="fa-stack" v-on:click="RemoveShift()">
                    <i class="fas fa-circle fa-stack-2x"></i>
                    <i class="fas fa-times fa-stack-2x"></i>
                </div>
            </div>
        </div>
        <drag ref="drag"/>
        <timebaruserselect ref="overlay"/>
        <dropdown v-for="(dropdown, id) in dropdowns" :dropdown="dropdown" :key="id"/>
    </div>
</template>

<script>
    var moment = require('moment');
    import drag from './drag.vue'
    import timebaruserselect from './TimeBarUserSelect.vue'
    import dropdown from '../uicomponents/dropdown.vue'
    export default {
        name: 'timebar',
        components: {
            drag,
            dropdown,
            timebaruserselect,
        },
        watch:{
        },
        data(){
            return{
                id: '',
                dropdowns: [],
                /*rota:{startDate: window.moment(), endDate: window.moment().add('hours', 8)},
                shift:{startDate: window.moment().add('hours', -.5), endDate: window.moment().add('hours', 7)},
                pauses:[
                    {startDate: window.moment().add('hours', 1), endDate: window.moment().add('hours', 1.5)},
                    {startDate: window.moment().add('hours', 2), endDate: window.moment().add('hours', 2.2)},
                ]*/
                event: {},
                startDrag: {x: 0, y: 0},
                dragEvent: '',
                dragTime: {},
                dragTimeCap: {},
                dragTimeInit: {},
                dragPauseId: -1,
                dragInterval: -1,
                dragPixelTimeRatio: 0,
                day: null,
                missingShiftStart: false,
                missingShiftEnd: false,
                dragging: false,
                timeDisplayLengthInMilliseconds: null,
                timeFrames: [],
                info: [],
                errors: [],
                warnings: [],
                employee: null,
                relative: null,
                timeFramesCopy: [],
                overrideContract: false,
                selectedTimeFrame: {},
                draggingTime: false,
                currentDate: moment(),
                moment: moment,
            }
        },
        computed: {
            shiftsSelected: function () { return window.roster.shiftsSelected; }
        },
        props:{
            eventProp: Object,
            employeeId: String,
        },
        created(){
            var view = this;
            window.addEventListener('resize', function(){requestAnimationFrame(function(){view.$forceUpdate()})});
            view.Init();
        },
        destroyed(){
            var view = this;
            document.body.removeEventListener('mouseup', view.EndDrag);
            window.removeEventListener('resize', this.$forceUpdate);
            window.clearTimeout(this.dragInterval);
        },
        beforeDestroy(){
            var view = this;
            if(this.$refs.overlay && this.$refs.overlay.$el) $(this.$refs.overlay.$el).remove();
            if(this.$refs.drag && this.$refs.drag.$el) $(this.$refs.drag.$el).remove();
            window.timebars = window.timebars.filter(t => t !== view);
        },
        updated(){
            var view = this;
            view.AdjustTimeFrameLabelsInbounds();
        },
        methods: {
            AdjustTimeFrameLabelsInbounds(){
                var view = this;
                if($(view.$el).closest('.table').length > 0) {
                    $(view.$el).find('.timeframe .label.start').each(function(i, e){
                                $(this).css({top: '', right: '', left: '', opacity: '0'});
                    });
                    $(view.$el).find('.timeframe .label.end').each(function(i, e){
                                $(this).css({top: '', right: '', left: '', opacity: '0'});
                    });
                }
                requestAnimationFrame(function(){
                    $(view.$el).find('.label.end').each(function(i, e){
                        $(this).css({opacity: ''});
                        var boxEnd = $(this)[0].getBoundingClientRect();
                        var start = $(this).parent().find('.label.start');
                        start.css({opacity: ''});
                        var boxStart = start[0].getBoundingClientRect();
                        var rightLimit = $('.app .shifts').length > 0 ? $('.app .shifts')[0].getBoundingClientRect().left : $(this).closest('.table')[0].getBoundingClientRect().right;
                        var leftLimit = $(this).closest('.table')[0].getBoundingClientRect().left;
                        var boxTimebar = $(this).parent().parent()[0].getBoundingClientRect();
                        var boxTimeframe = $(this).parent()[0].getBoundingClientRect();
                        if(boxTimebar.left > leftLimit) leftLimit = boxTimebar.left;
                        if(boxTimebar.right < rightLimit) rightLimit = boxTimebar.right;
                        if(boxTimeframe.left > leftLimit) leftLimit = boxTimeframe.left;
                        if(boxTimeframe.right < rightLimit) rightLimit = boxTimeframe.right;
                        if(rightLimit - boxEnd.left < 35){
                            $(this).css('top', (rightLimit - boxStart.left < 35) ? '10px' : '');
                            $(this).css('right', 'initial');
                            $(this).css('left', (rightLimit - boxTimeframe.left - 35) + 'px');
                        }
                        if(boxEnd.left - 5 < leftLimit){
                            $(this).css('top', (boxStart.left - 5 < leftLimit) ? '10px' : '');
                            $(this).css('right', 'initial');
                            $(this).css('left', (leftLimit - boxTimeframe.left + 5) + 'px');
                        }

                        if(rightLimit - boxStart.left < 35){
                            start.css('right', 'initial');
                            var newOffset = rightLimit - boxTimeframe.left - 35;
                            start.css('left', newOffset > 5 ? '' : (newOffset) + 'px');
                        }
                         if(boxStart.left - 5 < leftLimit){
                            start.css('right', 'initial');
                            var newOffset = leftLimit - boxTimeframe.left + 5;
                            start.css('left', newOffset < 5 ? '' : (newOffset) + 'px');
                        }
                        if(boxStart.right + 5 > boxEnd.left){
                            $(this).css('top', '10px');
                        }


                        /*
                        if(boxStart.right > boxEnd.left){
                                $(this).css('top', '11px');
                                $(this).css('right', '');
                                $(this).css('left', start.css('left'));
                        } else if($(this).parent().width() < 80 || rightLimit - boxEnd.left < 30) {
                            if($(this).parent().width() < 45)
                            {
                                $(this).css('top', '11px');
                                $(this).css('right', 'initial');
                                $(this).css('left', '0px');
                                $(this).parent().find('.label.start').css('left', '0px');
                            }
                            else
                                $(this).css('top', '11px');
                                $(this).css('right', 'initial');
                                $(this).css('left', (rightLimit - boxTimeframe.left - 30) + 'px');
                        } else {
                            if($(this).parent().hasClass('rota'))$(this).parent().css('height', '');
                            $(this).css('right', '');
                            $(this).css('left', '');
                            $(this).css('top', '');
                            $(this).parent().find('.label.start').css('left', '');
                        }
                         if(boxTimebar.right < boxEnd.right){

                                $(this).css('top', '11px');
                                $(this).css('right', '');
                                $(this).css('left', ((boxTimebar.right - rightLimit) - boxEnd.width) + 'px');
                                $(this).parent().find('.label.start').css('left', ((boxTimebar.right - rightLimit) - boxEnd.width) + 'px');
                        }*/
                    });
                });
            },
            ToggleOverlay($event, selection){
                var view = this;
                if(selection[0].shift && window.roster.shiftsSelected.find(s => s === selection[0].shift)){
                    window.roster.shiftsSelected = window.roster.shiftsSelected.filter(s => s !== selection[0].shift);
                    return;
                }
                if(selection[0].shift && !window.roster.shiftsSelected.find(s => s === selection[0].shift)) {
                    window.roster.shiftsSelected.push(selection[0].shift);
                }
                if(selection[0].shift && selection[0].shift.published) return;
                
                window.roster.UpdateTimeTableBorders([]);
                window.roster.$forceUpdate();
                this.$refs.overlay.Init({
                    elRelative: $event.currentTarget,
                    shift: selection[0].shift,
                    callbackEnd: function(newUserForShift){
                        var timebarComponent = window.timebars.find(t => t && t.eventProp && t.eventProp.employee && t.eventProp.employee.id === newUserForShift.id);
                        if(timebarComponent){
                            var shift = selection[0].shift;
                            var employee = timebarComponent.eventProp.employee;
                            if(employee){
                                var employeePrev = window.roster.employeeMap[shift.employeeId];
                                if(employeePrev)
                                {
                                    employeePrev.shiftsDate[shift.fromDate.format('YYYY-MM-DD')] = employeePrev.shiftsDate[shift.fromDate.format('YYYY-MM-DD')].filter(s => s !== shift);
                                    employeePrev.shifts = employeePrev.shifts.filter(s => s !== shift);
                                }
                                shift.employeeId = employee.id;
                                if(!employee.shiftsDate) employee.shiftsDate = {};
                                if(!employee.shifts) employee.shifts = [];
                                if(!employee.shiftsDate[shift.fromDate.format('YYYY-MM-DD')]) employee.shiftsDate[shift.fromDate.format('YYYY-MM-DD')] = [];
                                employee.shiftsDate[shift.fromDate.format('YYYY-MM-DD')].push(shift);
                                employee.shifts.push(shift);
                                window.roster.UpdateTimeTableBorders();
                                view.$emit('timebar-update-shift', { shift: shift, fields: {employeeId: employee.id}, clearEmployeeFilter: false});
                                window.roster.$forceUpdate();
                                timebarComponent.Init(timebarComponent.day);
                                view.Init(view.day);
                            }
                        }
                        view.$refs.overlay.toggled = false;
                    }
                });
            },
            extractDate: function(str){
                if(!this.$helpers.isBlank(str)) {
                    let split = str.split("T");
                    return split[0];
                } else {
                    return null;
                }
            },
            extractTime: function(str){
                if(!this.$helpers.isBlank(str)) {
                    let split1 = str.split("T");
                    let split2 = split1[1].split(":")
                    return split2[0]+":"+split2[1];
                } else {
                    return null;
                }

            },
            UpdateShift(shift){

                    if(this.eventProp.shiftTemplate){
                        this.UpdateHistoricShift(shift);
                        return;
                    }
                var view = this;
                    let url = '/api/sec/planshift';
                    url = view.$helpers.appendParam("storeId", view.$store.state.storeId, url, '/api/sec/planshift');
                    let payload = {
                      storeId: view.$store.state.storeId,
                      id: shift.id,
                      updateFields: []
                    }
                    var fields = {};
                     var fromNew = view.dragTime.format('YYYY-MM-DD') + 'T' + view.dragTime.format('HH:mm');
                     var toNew = view.dragTimeCap.format('YYYY-MM-DD') + 'T' + view.dragTimeCap.format('HH:mm');
                     if(parseInt(view.dragTimeInit.format('x')) > parseInt(view.dragTimeCap.format('x'))){
                        var temp = toNew;
                        toNew = fromNew;
                        fromNew = temp;
                     }
                     fields['from'] = view.$helpers.convertDateTimeString(view.extractDate(fromNew), view.extractTime(fromNew));
                     fields['to'] = view.$helpers.convertDateTimeString(view.extractDate(toNew), view.extractTime(toNew));
                    for(var x in fields){
                        var field = fields[x];
                        payload[x] = field;
                        payload.updateFields.push(x);
                    }
                    view.axios({
                        method: 'put',
                        headers: {
                            'AUTHORIZATION': "bearer "+view.$store.state.jwt
                        },
                        url: url,
                        data: payload
                    }).then(response => {
                        view.$helpers.success('Schicht Update', 'Schicht wurde aktualisiert')
                        window.roster.$forceUpdate();
                    }).catch(function (error) {
                        view.dragTime.year(view.dragTimeInit.year());
                        view.dragTime.month(view.dragTimeInit.month());
                        view.dragTime.date(view.dragTimeInit.date());
                        view.dragTime.hours(view.dragTimeInit.hours());
                        view.dragTime.minutes(view.dragTimeInit.minutes());
                        view.$helpers.error('Update fehlgeschlagen', 'Schicht Update fehlgeschlagen');
                    });
            },
            UpdateHistoricShift(shift){
                let view = this;

                window.app.popupalerts.push({header: 'Affect Linked Shifts', description: 'Affect future linked shifts by the change?', callbackAccept: function(popup){
                    popup.loading = true;
                    let url = '/api/sec/shifttemplate';
                    url = view.$helpers.appendParam("storeId", view.$store.state.storeId, url, '/api/sec/shifttemplate');
                    let payload = {
                      storeId: view.$store.state.storeId,
                      id: shift.templateId,
                      updateFields: []
                    }
                    var fields = {};
                     var fromNew = view.dragTime.format('YYYY-MM-DD') + 'T' + view.dragTime.format('HH:mm');
                     var toNew = view.dragTimeCap.format('YYYY-MM-DD') + 'T' + view.dragTimeCap.format('HH:mm');
                     if(parseInt(view.dragTimeInit.format('x')) > parseInt(view.dragTimeCap.format('x'))){
                        var temp = toNew;
                        toNew = fromNew;
                        fromNew = temp;
                     }
                     fields['from'] = view.$helpers.convertDateTimeString(null, view.extractTime(fromNew));
                     fields['to'] = view.$helpers.convertDateTimeString(null, view.extractTime(toNew));
                     fields['id'] = shift.id;
                    fields['updateShifts'] = true;
                    for(var x in fields){
                        var field = fields[x];
                        payload[x] = field;
                        payload.updateFields.push(x);
                    }
                    
                    view.axios({
                        method: 'put',
                        headers: {
                            'AUTHORIZATION': "bearer "+view.$store.state.jwt
                        },
                        url: url,
                        data: payload
                    }).then(response => {
                        popup.loading = false;
                        popup.hidden = true;
                        view.$helpers.success('Schichtvorlage Update', 'Schichtvorlage wurde aktualisiert')
                        window.roster.dayMode = false;
                        window.roster.refresh();
                    }).catch(function (error) {
                        popup.loading = false;
                        popup.hidden = true;
                        view.dragTime.year(view.dragTimeInit.year());
                        view.dragTime.month(view.dragTimeInit.month());
                        view.dragTime.date(view.dragTimeInit.date());
                        view.dragTime.hours(view.dragTimeInit.hours());
                        view.dragTime.minutes(view.dragTimeInit.minutes());
                        view.$helpers.error('Update fehlgeschlagen', 'Schicht Update fehlgeschlagen');
                    });
                }, callbackCancel: function(popup){
                    popup.loading = true;
                    let url = '/api/sec/shifttemplate';
                    url = view.$helpers.appendParam("storeId", view.$store.state.storeId, url, '/api/sec/shifttemplate');
                    let payload = {
                    storeId: view.$store.state.storeId,
                    id: shift.templateId,
                    updateFields: []
                    }
                    var fields = {};
                    var fromNew = view.dragTime.format('YYYY-MM-DD') + 'T' + view.dragTime.format('HH:mm');
                    var toNew = view.dragTimeCap.format('YYYY-MM-DD') + 'T' + view.dragTimeCap.format('HH:mm');
                    if(parseInt(view.dragTimeInit.format('x')) > parseInt(view.dragTimeCap.format('x'))){
                    var temp = toNew;
                    toNew = fromNew;
                    fromNew = temp;
                    }
                    fields['from'] = view.$helpers.convertDateTimeString(null, view.extractTime(fromNew));
                    fields['to'] = view.$helpers.convertDateTimeString(null, view.extractTime(toNew));
                     fields['id'] = shift.id;
                    fields['updateShifts'] = false;
                    for(var x in fields){
                        var field = fields[x];
                        payload[x] = field;
                        payload.updateFields.push(x);
                    }
                    view.axios({
                        method: 'put',
                        headers: {
                            'AUTHORIZATION': "bearer "+view.$store.state.jwt
                        },
                        url: url,
                        data: payload
                    }).then(response => {
                    popup.loading = false;
                    popup.hidden = true;
                    view.$helpers.success('Schicht Update', 'Historische Schichten aktualisiert');
                    }).catch(function (error) {
                        popup.loading = false;
                        popup.hidden = true;
                    view.dragTime.year(view.dragTimeInit.year());
                    view.dragTime.month(view.dragTimeInit.month());
                    view.dragTime.date(view.dragTimeInit.date());
                    view.dragTime.hours(view.dragTimeInit.hours());
                    view.dragTime.minutes(view.dragTimeInit.minutes());
                    view.$helpers.error('Update Fehler', 'Schicht Update fehlgeschlagen');
                    });
                }});
            },
            DragWatch(){
                var view = this;
                if(!window.mouse.click){
                    requestAnimationFrame(function(){view.draggingTime = false});
                    if(view.selectedTimeFrame.classes.indexOf('historic') !== -1) view.UpdateHistoricShift(view.selectedTimeFrame.shift);
                    if(view.selectedTimeFrame.classes.indexOf('shift') !== -1) view.UpdateShift(view.selectedTimeFrame.shift);

                    return;
                }
                var delta = window.mouse.x - this.startDrag.x;
                var dragPixelRatio = this.timeDisplayLengthInMilliseconds / $(this.$el).find('.background').width();
                dragPixelRatio = (1000 * 60);
                var millisecondDelta = parseInt(this.dragTimeInit.format('x')) + (delta * dragPixelRatio);
                millisecondDelta = Math.floor(millisecondDelta / (1000 * 60 * 5)) * (1000 * 60 * 5);

                var timeDelta = window.moment(millisecondDelta);
                /*if((isStartTime && (parseInt(timeEnd.format('x')) > parseInt(timeDelta.format('x'))))
                || (!isStartTime && (parseInt(timeStart.format('x')) < parseInt(timeDelta.format('x'))))) {*/

                if((parseInt(this.dragTimeInit.format('x')) > parseInt(this.dragTimeCap.format('x'))) && (parseInt(this.dragTime.format('x')) < parseInt(this.dragTimeCap.format('x')))) {
                    timeDelta = this.dragTimeCap.clone().add(5, 'minutes');
                }
                if((parseInt(this.dragTimeInit.format('x')) < parseInt(this.dragTimeCap.format('x'))) && (parseInt(this.dragTime.format('x')) > parseInt(this.dragTimeCap.format('x')))) {
                    timeDelta = this.dragTimeCap.clone().add(-5, 'minutes');
                }
                if((parseInt(this.dragTimeInit.format('x')) < parseInt(this.dragTimeCap.format('x')))) {

                    if(timeDelta.date() < this.day.date()) timeDelta = this.day.clone().hours(0).minutes(5);
                    if(timeDelta.date() > this.day.date()) timeDelta = this.day.clone().hours(23).minutes(55);
                }
                this.dragTime.year(timeDelta.year());
                this.dragTime.month(timeDelta.month());
                this.dragTime.date(timeDelta.date());
                this.dragTime.hours(timeDelta.hours());
                this.dragTime.minutes(timeDelta.minutes());
                this.$forceUpdate();
                requestAnimationFrame(function(){view.DragWatch()});
            },
            EndDrag(){
                this.dragEvent = '';
                if(this.dragPauseId !== -1)
                {

                    $(this.$el).find('.rota > .pause')[this.dragPauseId].querySelector('.pause-box').style.display = '';
                }

                this.dragPauseId = -1;
                this.shift.startHour = this.shift.startDate.hours();
                this.shift.startMinutes = this.shift.startDate.minutes();
                this.shift.endHour = this.shift.endDate.hours();
                this.shift.endMinutes = this.shift.endDate.minutes();
                for(var x in this.shift.pauses) {
                    var pause = this.shift.pauses[x];
                    pause.startHour = pause.startDate.hours();
                    pause.startMinutes = pause.startDate.minutes();
                    pause.endHour = pause.endDate.hours();
                    pause.endMinutes = pause.endDate.minutes();
                }
                //this.$parent.UpdateChildren();
                //this.$parent.CheckPauses(this.shift.pauses);
                //this.$parent.CheckErrors(this.event);
                this.Redraw();
                //this.$parent.$forceUpdate();
            },
            StartDrag($event, timeFrame, index, direction){
                if(timeFrame.shift && timeFrame.shift.published) return;
                var event = $event;
                var el = event.currentTarget;
                this.draggingTime = true;
                this.selectedTimeFrame = timeFrame;
                if(el.classList.contains('start')) this.dragTime = timeFrame.startDate;
                else this.dragTime = timeFrame.endDate;
                if(el.classList.contains('start')) this.dragTimeCap = timeFrame.endDate;
                else this.dragTimeCap = timeFrame.startDate;
                this.dragTimeInit = this.dragTime.clone();
                var posx = $(this.$el).find('.timeframe#' + index.toString() + ' .handle.' + direction);
                if(posx.length && posx.length > 0) posx = posx[0].getBoundingClientRect().left + ((posx[0].getBoundingClientRect().right - posx[0].getBoundingClientRect().left) * .5);
                else posx = window.mouse.x;
                this.startDrag = {x: posx, y: window.mouse.y};
                var view = this;
                view.$refs.drag.DragStop();
                view.dragging = false;
                requestAnimationFrame(function(){
                    view.$refs.drag.DragStop();
                    view.dragging = false;
                    view.DragWatch();
                });
            },
            GetShiftOptions(timeFrame){
                if(!timeFrame.shift) return [];
                var temp = [];
                temp.push({label: 'Unnassign', shift: timeFrame.shift});
                return temp;
            },
            ToggleDropDownShift: function ($event, selection, offsetx, offsety) {
                if(true) {
                    if(this.draggingTime) return;
                    this.ToggleOverlay($event, selection);
                    return;
                }
                if(this.draggingTime) return;
                if(selection.length === 0) return;
                var view = this;
                var event = $event;
                var box = event.currentTarget.getBoundingClientRect();
                var dropdowns = this.dropdowns;
                this.dropdowns.push({
                    items: selection,
                    el: event.currentTarget,
                    remainAfterSelect: true,
                    toggled: true,
                    offsetx: offsetx,
                    offsety: offsety,
                    posx: box.left + offsetx,
                    posy: box.bottom + offsety,
                    onceSelected: function ($eventInner, item, dropdown) {
                        view.RemoveShift(item.shift);
                        view.dropdowns = view.dropdowns.filter(d => d !== dropdown);
                    }
                });
            },
            RemoveShift(shift){
                if(shift.published) return;
                var employee = this.eventProp.employee;
                if(employee){
                    this.eventProp.employee.shiftsDate[shift.fromDate.format('YYYY-MM-DD')] = this.eventProp.employee.shiftsDate[shift.fromDate.format('YYYY-MM-DD')].filter(s => s !== shift);
                    this.eventProp.employee.shifts = this.eventProp.employee.shifts.filter(s => s !== shift);
                    delete shift.employeeId;
                    if(!employee.shiftsDate) employee.shiftsDate = {};
                    if(!employee.shifts) employee.shifts = [];
                    this.timeFramesCopy = this.timeFramesCopy.filter(t => !t.shift || (t.shift && t.shift !== shift));
                    this.$forceUpdate();
                    
                    this.$emit('timebar-update-shift', { shift: shift, fields: {employeeId: null}, clearEmployeeFilter: true});
                    
                }
            },
            PopulateByDay(day){
                this.timeFrames = [];
                this.timeFramesCopy = [];
                this.info = [];
                this.errors = [];
                this.warnings = [];
                this.day = day.clone();
                this.overrideContract = false;
                var view = this;
                if(this.eventProp.isShift){
                    var shift = this.eventProp.timeFrames[0].shift;
                    this.info.push({label: 'Shift', data: shift.fromDate.format('HH:mm') + ' - ' +  shift.toDate.format('HH:mm')});
                    this.info.push({label: 'Skill:', data: shift.spotId && window.roster.spotMap[shift.spotId].requiredSkill &&window.roster.spotMap[shift.spotId].requiredSkill !== '' ? window.roster.skillMap[window.roster.spotMap[shift.spotId].requiredSkill].name : '', half: true});
                    this.info.push({label: 'Spot:', data: shift.spotId ? window.roster.spotMap[shift.spotId].name : '', half: true});
                    return;
                }
                if(this.eventProp.shiftTemplateEntry){
                    var shift = this.eventProp.shiftTemplate;
                    var fromDate = day.clone().hours(shift.from.split(':')[0]).minutes(shift.from.split(':')[1].split('Z')[0]);
                    var toDate = day.clone().hours(shift.to.split(':')[0]).minutes(shift.to.split(':')[1].split('Z')[0]);
                    this.timeFrames.push({editable: true, classes: 'shift ' + (shift.published ? 'published' : ''), show: shift,  id: -1, start: fromDate.format('x'), startDate: fromDate, end: toDate.format('x'), endDate: toDate, shift: shift});
                    //if(shift.historicFrom) this.timeFrames.push({editable: true, classes: 'historic', show: shift,  id: -1, start: shift.historicFromDate.format('x'), startDate: shift.historicFromDate, end: shift.historicToDate.format('x'), endDate: shift.historicToDate, shift: shift});
                    //this.info.push({label: 'Skill:', data: shift.spotId && window.roster.spotMap[shift.spotId].requiredSkill &&window.roster.spotMap[shift.spotId].requiredSkill !== '' ? window.roster.skillMap[window.roster.spotMap[shift.spotId].requiredSkill].name : '', half: true});
                    //this.info.push({label: 'Spot:', data: shift.spotId ? window.roster.spotMap[shift.spotId].name: shift.spotId, half: true});
                    this.$forceUpdate();
                    requestAnimationFrame(function(){
                        view.$forceUpdate();
                    });
                    return;
                }
                if(this.eventProp.shiftTemplateUnassigned){
                    var shift = this.eventProp.shiftTemplateUnassigned;
                    var fromDate = shift.fromDate.clone();
                    var toDate = shift.toDate.clone();
                    this.timeFrames.push({editable: true, classes: 'shift ' + (shift.published ? 'published' : ''), show: shift,  id: -1, start: fromDate.format('x'), startDate: fromDate, end: toDate.format('x'), endDate: toDate, shift: shift});
                    if(shift.historicFrom) this.timeFrames.push({editable: true, classes: 'historic', show: shift,  id: -1, start: shift.historicFromDate.format('x'), startDate: shift.historicFromDate, end: shift.historicToDate.format('x'), endDate: shift.historicToDate, shift: shift});
                    //this.info.push({label: 'Skill:', data: shift.spotId ? window.roster.spotMap[shift.spotId].unitName : shift.spotId, half: true});
                    //this.info.push({label: 'Spot:', data: shift.spotId ? window.roster.spotMap[shift.spotId].name: shift.spotId, half: true});
                    this.$forceUpdate();
                    requestAnimationFrame(function(){
                        view.$forceUpdate();
                    });
                    return;
                }
                var employeeMapped = this.eventProp.employee;
                if(employeeMapped.availability)
                {
                    for(var x in employeeMapped.availability)
                    {
                        var availability = employeeMapped.availability[x];
                        //eventProp.info.push({label : availability.type.charAt(0).toUpperCase() + availability.type.slice(1).toLowerCase(), data: availability.from + ' - ' + availability.to});

                        var dayOfWeek = this.day.weekday();
                        if(availability.weekDays.find(w => w === dayOfWeek))
                        {
                            var availabilityClass = '';
                            if(availability.state === 1) availabilityClass = 'unavailable';
                            if(availability.state === 2) availabilityClass = 'work-hours';
                            if(availability.state === 3) availabilityClass = 'undesired';
                            if(availability.state === 4) availabilityClass = 'desired';
                            

                            this.timeFrames.push({classes: availabilityClass, id: -1, show:true, start: this.day.clone().hours(availability.from.split(':')[0]).minutes(availability.from.split(':')[1]).format('x'), startDate:  this.day.clone().hours(availability.from.split(':')[0]).minutes(availability.from.split(':')[1]), end:  this.day.clone().hours(availability.to.split(':')[0]).minutes(availability.to.split(':')[1]).format('x'), endDate: this.day.clone().hours(availability.to.split(':')[0]).minutes(availability.to.split(':')[1])});
                            if(parseInt(this.timeFrames[this.timeFrames.length - 1].startDate.format('x')) > parseInt(this.timeFrames[this.timeFrames.length - 1].endDate.format('x'))) this.timeFrames[this.timeFrames.length - 1].startDate.add(-1, 'day');
                        }
                    }
                }
                if(employeeMapped.preferencesDate && employeeMapped.preferencesDate[this.day.format('YYYY-MM-DD')])
                {
                    for(var x in employeeMapped.preferencesDate[this.day.format('YYYY-MM-DD')])
                    {
                        var preference = employeeMapped.preferencesDate[this.day.format('YYYY-MM-DD')][x];
                        let preferenceClass = '';
                        if(preference.state === 1) preferenceClass = 'unavailable';
                        if(preference.state === 2) preferenceClass = 'work-hours';
                        if(preference.state === 3) preferenceClass = 'undesired';
                        if(preference.state === 4) preferenceClass = 'desired';
                        
                        if(preference.overrideContract) this.overrideContract = true;
                        this.timeFrames.push({approved: preference.approved, classes: preferenceClass, id: -1, show:true, startDate:  preference.fromDate.clone(), endDate: preference.toDate.clone()});
                        if(parseInt(this.timeFrames[this.timeFrames.length - 1].startDate.format('x')) >= parseInt(this.timeFrames[this.timeFrames.length - 1].endDate.format('x'))) this.timeFrames[this.timeFrames.length - 1].endDate.add(1, 'day');
                    }
                }

                this.info.push({label: 'Store:', data: $('.menu-bar input').val()});
                var shifts = Object.values(window.roster.planShiftMap).filter(s => s.from && s.from.split('T')[0] === view.day.format('YYYY-MM-DD') && s.employeeId === employeeMapped.id);
                for(var x in shifts)
                {
                    var shift = shifts[x];
                    //console.log(shift);
                    this.timeFrames.push({editable: true, classes: 'shift ' + (shift.published ? 'published' : ''), show: shift,  id: -1, start: shift.fromDate.format('x'), startDate: shift.fromDate, end: shift.toDate.format('x'), endDate: shift.toDate, shift: shift});
                    if(shift.historicFrom) this.timeFrames.push({editable: true, classes: 'historic', show: shift,  id: -1, start: shift.historicFromDate.format('x'), startDate: shift.historicFromDate, end: shift.historicToDate.format('x'), endDate: shift.historicToDate, shift: shift});
                    this.info.push({label: 'Skill:', data: shift.spotId ? window.roster.spotMap[shift.spotId].unitName : shift.spotId, half: true});
                    this.info.push({label: 'Spot:', data: shift.spotId ? window.roster.spotMap[shift.spotId].name: shift.spotId, half: true});
                    if(shift.spotId && !window.roster.HasSkill(this.eventProp.employee, window.roster.skillMap[window.roster.spotMap[shift.spotId].requiredSkill])) this.errors.push({label: 'Skill Missing:', data: 'Missing ' + window.roster.spotMap[shift.spotId].name + ' skill'});
                }
                if(window.roster.CheckShiftAvailabilityOverlap(this.eventProp.employee, this.day, 1)) this.errors.push({label: 'Unavailable Overlap:', data: 'Employee unavailable during shift'});
                //if(window.roster.CheckShiftAvailabilityOverlap(this.eventProp.employee, this.day, 'VACATION')) this.errors.push({label: 'Vacation Overlap:', data: 'Employee on vacation for scheduled shift'});
                if(window.roster.CheckShiftOverlap(this.eventProp.employee, this.day)) this.errors.push({label: 'Shifts Overlap:', data: 'Shift timeframes overlap'});
                if(this.day.hours() + (this.timeDisplayLengthInMilliseconds / (1000 * 3600)) > 24) this.AddDay(day.clone().add(1, 'day'));
                var shiftsBefore = employeeMapped.shifts ? employeeMapped.shifts.filter(s => s.fromDate.format('YYYY-MM-DD') === this.day.clone().add(-1, 'day').format('YYYY-MM-DD')) : [];
                if(shiftsBefore.find(s => s.toDate.date() === day.date())) this.AddDay(day.clone().add(-1, 'day'));
                this.$forceUpdate();
            },
            AddDay(day){
                var view = this;
                day = day.clone();
                //this.overrideContract = false;
                if(this.eventProp.isShift){
                    var shift = this.eventProp.timeFrames[0].shift;
                    this.info.push({label: 'Shift', data: shift.fromDate.format('HH:mm') + ' - ' +  shift.toDate.format('HH:mm')});
                    this.info.push({label: 'Skill:', data: shift.spotId ? window.roster.spotMap[shift.spotId].unitName : '', half: true});
                    this.info.push({label: 'Spot:', data: shift.spotId ? window.roster.spotMap[shift.spotId].name : '', half: true});
                    return;
                }
                var employeeMapped = this.eventProp.employee;
                if(employeeMapped.availability)
                {
                    for(var x in employeeMapped.availability)
                    {
                        var availability = employeeMapped.availability[x];
                        //eventProp.info.push({label : availability.type.charAt(0).toUpperCase() + availability.type.slice(1).toLowerCase(), data: availability.from + ' - ' + availability.to});

                        var dayOfWeek = day.weekday();
                        if(availability.weekDays.find(w => w === dayOfWeek))
                        {
                            var availabilityClass = '';
                            if(availability.state === 2) availabilityClass = 'work-hours';
                            if(availability.state === 1) availabilityClass = 'unavailable';
                            if(availability.state === 3) availabilityClass = 'undesired';
                            if(availability.state === 4) availabilityClass = 'desired';
                            

                            this.timeFrames.push({classes: availabilityClass, id: -1, show:true, start: day.clone().hours(availability.from.split(':')[0]).minutes(availability.from.split(':')[1]).format('x'), startDate:  day.clone().hours(availability.from.split(':')[0]).minutes(availability.from.split(':')[1]), end:  day.clone().hours(availability.to.split(':')[0]).minutes(availability.to.split(':')[1]).format('x'), endDate: day.clone().hours(availability.to.split(':')[0]).minutes(availability.to.split(':')[1])});
                            if(parseInt(this.timeFrames[this.timeFrames.length - 1].startDate.format('x')) > parseInt(this.timeFrames[this.timeFrames.length - 1].endDate.format('x'))) this.timeFrames[this.timeFrames.length - 1].startDate.add(-1, 'day');
                        }
                    }
                }
                if(employeeMapped.preferencesDate && employeeMapped.preferencesDate[day.format('YYYY-MM-DD')])
                {
                    for(var x in employeeMapped.preferencesDate[day.format('YYYY-MM-DD')])
                    {
                        var preference = employeeMapped.preferencesDate[day.format('YYYY-MM-DD')][x];
                        let preferenceClass = '';
                        if(preference.state === 1) preferenceClass = 'unavailable';
                        if(preference.state === 2) preferenceClass = 'work-hours';
                        if(preference.state === 3) preferenceClass = 'undesired';
                        if(preference.state === 4) preferenceClass = 'desired';

                        if(preference.overrideContract) this.overrideContract = true;
                        this.timeFrames.push({approved: preference.approved, classes: preferenceClass, id: -1, show:true, startDate:  preference.fromDate.clone(), endDate: preference.toDate.clone()});
                        if(parseInt(this.timeFrames[this.timeFrames.length - 1].startDate.format('x')) >= parseInt(this.timeFrames[this.timeFrames.length - 1].endDate.format('x'))) this.timeFrames[this.timeFrames.length - 1].endDate.add(1, 'day');
                    }
                }

                this.info.push({label: 'Store:', data: $('.menu-bar input').val()});
                var shifts = Object.values(window.roster.planShiftMap).filter(s => s.from && s.from.split('T')[0] === view.day.format('YYYY-MM-DD') && s.employeeId === employeeMapped.id);
                for(var x in shifts)
                {
                    var shift = shifts[x];
                    this.timeFrames.push({editable: true, classes: 'shift ' + (shift.published ? 'published' : ''), show: shift,  id: -1, start: shift.fromDate.format('x'), startDate: shift.fromDate, end: shift.toDate.format('x'), endDate: shift.toDate, shift: shift});
                    if(shift.historicFromDate) this.timeFrames.push({editable: true, classes: 'historic', show: shift,  id: -1, start: shift.historicFromDate.format('x'), startDate: shift.historicFromDate, end: shift.historicToDate.format('x'), endDate: shift.historicToDate, shift: shift});
                    this.info.push({label: 'Skill:', data: shift.spotId ? window.roster.spotMap[shift.spotId].unitName : shift.spotId, half: true});
                    this.info.push({label: 'Spot:', data: shift.spotId ? window.roster.spotMap[shift.spotId].name: shift.spotId, half: true});
                    if(shift.spotId && !window.roster.HasSkill(this.eventProp.employee, window.roster.skillMap[window.roster.spotMap[shift.spotId].requiredSkill])) this.errors.push({label: 'Skill Missing:', data: 'Missing ' + window.roster.spotMap[shift.spotId].name + ' skill'});
                }
                if(window.roster.CheckShiftAvailabilityOverlap(this.eventProp.employee, day, 1)) this.errors.push({label: 'Unavailable Overlap:', data: 'Employee unavailable during shift'});
                //if(window.roster.CheckShiftAvailabilityOverlap(this.eventProp.employee, day, 'VACATION')) this.errors.push({label: 'Vacation Overlap:', data: 'Employee on vacation for scheduled shift'});
                if(window.roster.CheckShiftOverlap(this.eventProp.employee, day)) this.errors.push({label: 'Shifts Overlap:', data: 'Shift timeframes overlap'});

                this.$forceUpdate();
            },
            Init(day){
                var view = this;
                if(this.employeeId) this.eventProp.employee = window.roster.employeeMap[this.employeeId];
                if(!window.timebars) window.timebars = [];
                //window.timebars = window.timebars.filter(t => t && $(t.$el).closest('html').length > 0);
                if(!window.timebars.find(t => t === this)) window.timebars.push(view);
                view.event = view.eventProp;
                if(view.$refs.overlay) view.$refs.overlay.toggled = false;
                view.eventProp.timebar = view;
                if(day) view.PopulateByDay(day);
                else view.PopulateByDay(view.eventProp.day);

                if(!view.day) view.day = view.startTime ? view.day.clone().hour(view.startTime) : view.day.clone();
                view.timeFramesCopy = [];
                var shifts = view.timeFramesCopy.filter(s => s.shift);
                for(var x in shifts)
                {
                    var shift = shifts[x];
                    if(!shift.timebars) shift.timebars = [];
                    shift.timebars = shift.timebars.filter(t => t);
                    shift.timebars.push(view);
                }
                /*for(var x in view.timeFramesCopy){
                    var timeFrame = view.timeFramesCopy[x];
                    if(timeFrame.classes.indexOf('shift') === -1 && parseInt(timeFrame.startDate.format('x')) < parseInt(view.day.format('x'))){
                        var timeFrameDayShifted = {};
                        for(var y in timeFrame){
                            timeFrameDayShifted[y] = timeFrame[y];
                            if(timeFrameDayShifted[y].format) timeFrameDayShifted[y] = timeFrameDayShifted[y].clone().add(1, 'day');
                        }
                        view.timeFramesCopy.push(timeFrameDayShifted);
                    }
                }*/
                if(!view.timeDisplayLengthInMilliseconds)
                {
                    if(view.timeDisplayLengthInMilliseconds) view.timeDisplayLengthInMilliseconds = view.timeDisplayLengthInMilliseconds;
                    else view.timeDisplayLengthInMilliseconds = 86400000; //milliseconds in one day
                }
                if(view.eventProp.employee && !view.eventProp.shiftTemplateEntry) {
                    view.eventProp.employee.dayModeClasses = window.roster.GetDayAvailabilityType(view.eventProp.employee, window.roster.dayModeDate);
                    window.roster.$forceUpdate()
                }
                if(view.eventProp.hideBar) return;
                requestAnimationFrame(function(){
                    view.AdjustTimeFrameLabelsInbounds();
                    view.$forceUpdate();
                });
            },
            DragStartShift: function ($event, shift) {
                if(shift.published) return;
                if($(window.mouse.element).closest('.handle').length > 0) return;
                var view = this;
                /*var mousetemp = {x: window.mouse.x, y: window.mouse.y};
            || Math.abs(mousetemp.x - window.mouse.x) < 10 || Math.abs(mousetemp.y - window.mouse.y) < 10*/
                setTimeout(function(){
                    if(!window.mouse.click || view.draggingTime) return;
                    $($(view.$parent.$el).find('.background')[0]).css('display', 'none');
                    window.roster.UpdateTimeTableBorders([shift]);

                    view.$parent.sollIstDragging.employeeIdOld = shift.employeeId;
                    view.$parent.sollIstDragging.shiftTimeinMinutes = shift.helperHolidayValue + Math.floor((shift.toDate.unix() - shift.fromDate.unix())/60);

                    view.dragging = true;
                    view.$parent.dragging = true;
                    view.$parent.FilterSpot(shift.spotId,true);
                    var event = $event;
                    view.$refs.drag.info = [];
                    view.$refs.drag.info.push({label: 'Shift', data: shift.fromDate.format('HH:mm') + ' - ' +  shift.toDate.format('HH:mm')});
                    view.$refs.drag.info.push({label: 'Skill:', data: shift.spotId ? window.roster.spotMap[shift.spotId].unitName : '', half: true});
                    view.$refs.drag.info.push({label: 'Spot:', data: shift.spotId ? window.roster.spotMap[shift.spotId].name : '', half: true});
                    view.$refs.drag.DragStart(event.pageX, event.pageY, shift);
                    view.$refs.drag.callbackEnd = view.DragEndShift;
                }, 200);
            },
            DragEndShift: function (shift) {
                this.$parent.sollIstDragging.employeeIdOld = null;

                $($(this.$parent.$el).find('.background')[0]).css('display', '');
                if(!this.dragging) return;
                window.roster.UpdateTimeTableBorders([]);
                var view = this;


                requestAnimationFrame(function(){view.dragging = false;view.$parent.dragging = false});
                var unassign = $(window.mouse.element).closest('.shifts');

                if(unassign.length > 0){
                    this.RemoveShift(shift);
                    requestAnimationFrame(function(){view.Init(view.day)});
                    return;
                }

                var timebar = $(window.mouse.element).closest('.time-bar-new');
                if(timebar){
                    var timebarComponent = window.timebars.find(t => t.$el === timebar[0]);
                    if(timebarComponent){
                        var employee = timebarComponent.eventProp.employee;
                        if(employee){
                            var employeePrev = window.roster.employeeMap[shift.employeeId];
                            if(employeePrev)
                            {
                                employeePrev.shiftsDate[shift.fromDate.format('YYYY-MM-DD')] = employeePrev.shiftsDate[shift.fromDate.format('YYYY-MM-DD')].filter(s => s !== shift);
                                employeePrev.shifts = employeePrev.shifts.filter(s => s !== shift);
                            }
                            shift.employeeId = employee.id;
                            if(!employee.shiftsDate) employee.shiftsDate = {};
                            if(!employee.shifts) employee.shifts = [];
                            if(!employee.shiftsDate[shift.fromDate.format('YYYY-MM-DD')]) employee.shiftsDate[shift.fromDate.format('YYYY-MM-DD')] = [];
                            employee.shiftsDate[shift.fromDate.format('YYYY-MM-DD')].push(shift);
                            employee.shifts.push(shift);
                            view.$parent.UpdateSollIstMapEntry(employee,shift);
                           //window.roster.UpdateTimeTableBorders([]);
                            this.$emit('timebar-update-shift', { shift: shift, fields: {employeeId: employee.id}, clearEmployeeFilter: true});
                            
                            window.roster.$forceUpdate();
                            timebarComponent.Init(timebarComponent.day);

                        }
                    }
                }
                var day = $(window.mouse.element).closest('.day');
                if(day && day.length > 0){
                    var el = day[0];
                    var dayDate = moment(el.attributes['year'].value + '-' +el.attributes['month'].value + '-' +el.attributes['day'].value, 'YYYY-MM-DD');
                    var entry = day.closest('.entry');
                    var employeeId = day.attr('employeeId');

                    var employee = window.roster.employees.find(e => e.id === employeeId);
                    if(employee){
                        var employeePrev = window.roster.employeeMap[shift.employeeId];
                        if(employeePrev)
                        {
                            employeePrev.shiftsDate[shift.fromDate.format('YYYY-MM-DD')] = employeePrev.shiftsDate[shift.fromDate.format('YYYY-MM-DD')].filter(s => s !== shift);
                            employeePrev.shifts = employeePrev.shifts.filter(s => s !== shift);
                        }
                        shift.employeeId = employee.id;
                        if(!employee.shiftsDate) employee.shiftsDate = {};
                        if(!employee.shifts) employee.shifts = [];
                        if(!employee.shiftsDate[shift.fromDate.format('YYYY-MM-DD')]) employee.shiftsDate[shift.fromDate.format('YYYY-MM-DD')] = [];
                        employee.shiftsDate[shift.fromDate.format('YYYY-MM-DD')].push(shift);
                        employee.shifts.push(shift);
                        this.$emit('timebar-update-shift', { shift: shift, fields: {employeeId: employee.id}, clearEmployeeFilter: true});
                        
                       
                    }
                }


                requestAnimationFrame(function(){
                    view.$forceUpdate();
                    view.$parent.toggled = false;
                });
                this.Init(this.day);
            },
            AddPause(){
                //this.$parent.AddPause(this.eventProp.day, this.eventProp.employee, this.event);
            },
            Redraw(){
                this.$forceUpdate();
                var bar = this;
                requestAnimationFrame(function(){
                    bar.DrawDesired();
                    bar.DrawShift();
                    bar.DrawOvertime();
                    bar.DrawPauses();
                });
            },
            GetOffset(timeFrame){
                var bar = this;
                if(!this.$el || !this.$el.querySelector){
                    return;
                };
                var styles = timeFrame.styles ? timeFrame.styles : {};
                var background = this.$el.querySelector('.background:not(.tomorrow):not(.yesterday)');
                //var daytime = parseInt(this.timeDisplayLengthInMilliseconds) - parseInt(this.day.clone().hours() * 60 * 60 * 1000);
                var daytime = this.timeDisplayLengthInMilliseconds;
                var timeFrameWidth = window.moment.duration(timeFrame.endDate.diff(timeFrame.startDate)).asMilliseconds();

                //var rotawidth = (parseInt(window.getComputedStyle($(this.$el).find('.rota')[0]).getPropertyValue('width').split('px')[0]));
                var widthratio = $(background).width() / (daytime);

                //if(!timeFrame.show) return {};
                styles["width"] = (widthratio * timeFrameWidth).toString() + 'px';
                styles["left"] = (widthratio * (parseInt(timeFrame.startDate.format('x')) - parseInt(this.day.clone().minutes(0).format('x')))).toString() + 'px';
                return styles;
            },
            GetOffsetTomorrow(){
                var bar = this;
                if(!this.$el || !this.$el.querySelector || !this.day){
                    return;
                };
                var styles = {};
                var background = this.$el.querySelector('.background:not(.tomorrow):not(.yesterday)');
                var daytime = this.timeDisplayLengthInMilliseconds;

                var widthratio = $(background).width() / (daytime);

                styles["left"] = (widthratio + (widthratio * (parseInt(this.day.clone().add(1, 'days').hours(0).format('x')) - parseInt(this.day.format('x'))))).toString() + 'px';
                return styles;
            },
            GetOffsetYesterday(){
                var bar = this;
                if(!this.$el || !this.$el.querySelector || !this.day){
                    return;
                };
                var styles = {};
                var background = this.$el.querySelector('.background:not(.tomorrow):not(.yesterday)');
                var daytime = this.timeDisplayLengthInMilliseconds;

                var widthratio = $(background).width() / (daytime);

                styles["left"] = (widthratio - (widthratio * (parseInt(this.day.clone().add(-1, 'days').hours(0).format('x')) - parseInt(this.day.format('x'))))).toString() + 'px';
                return styles;
            },
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    .label{
        position: absolute;
        top: 0px;
        font-size: 10px;
        border-radius: 100px;
        padding: 0 5px;
    width: fit-content;
    }

    .timeframe .label{

        color: black;
    }

    .hour-grid{
        pointer-events: none;
        position: absolute;
        left: 0;
        top: -5px;
        width: 100%;
        height: 90px;
        z-index: -1;
        padding: 30px 10px 0;
    }
    .fixed .hour-grid,.shift .hour-grid{

        display: none;
    }


    .time-marks{
        width: 100%;
        height: 100%;
        display: inline-block;
    }

    .time-marks .label{
        position: absolute;
        top: -20px;
        left: -15px;
        width: 30px;
        text-align: center;
    }

    .time-marks .mark{
        position: relative;
        float: left;
        width: calc(100% / 24);
        height: 100%;
        display: inline-block;
        box-shadow: inset 2px 0px 0 -1px var(--contrast-1);
        background: none;
    }
    .hour-grid.full-half .time-marks .mark{
        width: calc(100% / 36);
    }
    .hour-grid.full .time-marks .mark{
        width: calc(100% / 24);
    }
    .hour-grid.half .time-marks .mark{
        width: calc(100% / 12);
    }
    .hour-grid.quarter .time-marks .mark{
        width: calc(100% / 6);
    }
    .time-marks .mark.am{
    }
    .label.start{
        left: 5px;
    }

    .label.end{
        right: 5px;
    }

    .desired .label, .work-hours .label, .unavailable .label, .undesired .label{
        color: var(--contrast-4);
    }

    .time-bar-new{
        width: 450px;
        position: relative;
        z-index: 2;
        padding-top: 15px;
    }

    .time-bar-new.fixed{
        padding-top: initial;
        width: 100%;
    }
    .time-bar-new.shift{
        background: white;
        box-shadow: 4px 4px 5px 3px rgba(0,0,0,0.2);
    }

    .background{
        background: none;
        position: relative;
        height: 60px;
        min-width: 300px;
        width: calc(100% - 20px);
        left: 0;
        right: 0;
        bottom: 0;
        margin:auto;
        border-radius: 0;
        overflow: hidden;
        margin: 10px;
    }


    .fixed .background{
        height: 44px;
        top: 3px;
        background: none;
        margin-left: 0;
        margin-right: 0;
        width: 100%;
    }


    .rota,.work-hours{
        background: #cccccc;
        position: absolute;
        height: 40px;
        bottom: 0;
        border-radius: 10px;
    }

    .timeframe{
        position: absolute;
        height: 100%;
        bottom: 0;
    }

    .timeframe.locked,.timeframe.published,.timeframe.historic{
         /*pointer-events: none;*/
     }
    .timeframe.published .handle,.timeframe.historic .handle{
        display: none;
    }

    .timeframe.locked-start .handle.start{
        pointer-events: none;
        opacity: 0;
    }

    .work-hours{
        background: rgba(0,0,0,.1);
        pointer-events: none;
    }
    .unavailable{
        background: rgba(150,0,0,.5);
        pointer-events: none;
    }
    .shift
    {
        cursor: pointer;
    }

    .shift, .desired{
        background: #b2b2b2;
        position: absolute;
        height: 25px;
        width: 450px;
        bottom: 0;
        border-radius: 10px;
    }

    .shift-only .shift{
        background: #cccccc;
    }

    .desired{
        background: rgba(0,125,0,.3);
    }
    .undesired{
        background: rgba(125,125,0,.3);
    }

    .work-hours, .desired{
        height: 100%;
        border-radius: 0;
    }

    .off-hours{
        background: rgba(0,0,0,.5);
        position: absolute;
        top: 0;
        height: 100%;
        width: 100%;
    }

    .off-hours.left{
        right: 100%;
    }

    .off-hours.right{
        left: 100%;
    }

    .overtime{
        background: #b22212;
        position: absolute;
        height: 100%;
        width: 0px;
    }
    .overtime.end{

        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
    }
    .overtime.start{

        border-top-left-radius: 10px;
        border-bottom-left-radius: 10px;
    }

    .pause{
        background: #ddbd1d;
        position: absolute;
        height: 110%;
        bottom: 0;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
    }

    .dragbox{
        height: 100%;
        position: absolute;
        top: 0;
        width: 10px;
        cursor: pointer;
    }

    .dragbox.start{
        left: -5px;
    }
    .dragbox.end{
        right: -5px;
    }

    .fa-map-marker{
        position: absolute;
        left: 0;
        right: 0;
        margin: auto;
        cursor: pointer;
        overflow: hidden;
    }

    .rota .fa-map-marker{
        color: #cccccc;
        top: -17px;
    }
    .shift .fa-map-marker{
        transform: scaleY(-1);
        color: #b2b2b2;
        bottom: -17px;
        z-index: 1;
    }
    .pause .fa-map-marker{
        transform: scaleY(-1);
        color: #ddbd1d;
        bottom: -17px;
        z-index: 1;
    }
    .fa-map-marker.add-pause{
        transform: scaleY(-1);
        color: #ddbd1d;
        bottom: -35px;
        height: 15px;
        top: initial;
        width: 20px;
    }
    .fa-map-marker .fa-plus{
        position: absolute;
        color: white;
        top: 1px;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        font-size: 10px;
        pointer-events: none;
    }

    .start .fa-map-marker{
        width: 50%;
        left: 0;
        right: initial;
    }
    .end .fa-map-marker{
        width: 50%;
        right: 0;
        left: initial;
    }
    .end .fa-map-marker:before{
        margin-left: -7px;
    }

    .pause-box{
        display: none;
        position: absolute;
        bottom: 100%;
        border-radius: 10px;
        background: #ddbd1d;
        text-align: center;
        transform: translateY(-10px);
        left:-50000%;
        right:-50000%;
        margin: auto;
        width: 80px;
    }
    .pause-box .label{
        position: relative;
        color: white;
        padding: 0 5px;
        float: left;
        width: 100%;
        text-align: center;
        left: 0;
        right: 0;
    }
    .pause-box .label.start{
        width: 50%;
    }
    .pause-box .label.end{
        width: 50%;
    }
    .pause:hover .pause-box{
        display: inline-block;
    }

    .label.missing{
        margin: auto;
        top: 0;
        left: 0;
        right: 0;

    }

    .dragbox#rota{
        display: none;
    }

    .info{
        width: 100%;
        position: relative;
        padding: 10px;
        padding-top: 0;
    }

    .entry {
        width: 100%;
        float: left;
        height: 23px;
        display: flex;
    }
    .entry.half {
        width: 50%;
    }
    .entry > .label{
        width: initial;
        height: 20px;
        position: relative;
        margin-right: 5px;
        font-size: 14px;
        margin: 0;
        text-align: right;
    }
    .entry > .data{
        flex: auto;
        height: 20px;
        position: relative;
        font-size: 14px;
        margin-left: 5px;
        box-shadow: 0 2px 0 -1px var(--contrast-1);
        color: var(--contrast-4);
    }

    .fixed .info,
    .fixed .error,
    .fixed .warning{
        display: none;
    }
    .shift .info{
        top: -6px;
    }


    .info .entry:last-child{
        margin-bottom: 10px;
    }

    .employee {
        display: inline-block;
        position: relative;
        cursor: pointer;
        -webkit-transition: .2s;
        transition: .2s;
        padding: 10px;
        padding-bottom: 30px;
        padding-top: 6px;
        padding-left: 40px;
        border-radius: 5px;
        height: 45px;
        opacity: 1;
        width: 90%;
        margin-top: 10px;
        margin-bottom: 0px;
        box-shadow: inset 0 0 0 1px #a9a9a9;
    }

    .employee:hover {
        background: rgba(0, 0, 0, .1);
    }

    .employee * {
        cursor: pointer;
    }

    .employee .picture {
        background-size: 100%;
        position: absolute;
        height: 30px;
        width: 30px;
        left: 5px;
        top: 7px;
        border-radius: 3px;
    }

    .employee .namefirst {
        font-size: 10px;
        color: dimgray;
        text-align: left;
		height: 15px;
        white-space: nowrap;
    }

    .employee .namelast {
        font-size: 11px;
        color: dimgray;
        text-align: left;
		height: 15px;
        white-space: nowrap;
    }

    .employee .progressbar {
        position: absolute;
        width: calc(100% - 10px);
        right: 0;
        margin: auto;
        bottom: 5px;
        height: 6px;
        border-radius: 100px;
        background: #c1c1c1;
        left: 0;
        overflow: hidden;
    }

    .employee .progressbar .progressfill {
        position: absolute;
        width: 50%;
        bottom: 00px;
        height: 100%;
        border-radius: 100px;
        background: gray;
        left: 0;
    }

    .fa-stack{
        position: absolute;
        right: -8px;
        top: -8px;
        font-size: 10px;
    }

    .fa-stack .fa-circle {
        color: #808080;
    }

    .fa-stack .fa-times{
        transform: scale(.7) translateX(0px);
    }

    .shift{
        z-index: 7;
        border-radius: 5px;
        background: #b2b2b2;
    }

    .shift.published{
        background: #6d8d22;
    }
    .historic,.template{
        z-index: 6;
        background: #e5e5e5;
        border-radius: 5px;
        height: 45px;
    }

    .fixed .historic{
        height: 100%;
    }

    .vacation{
        z-index: 5;
        background: rgba(255, 165, 0, 0.5);
    }
    .unavailable{
        z-index: 4
    }
    .undesired{
        z-index: 3
    }
    .desired{
        z-index: 2
    }

    .error .data{
        box-shadow: 0 3px 0 -1px rgba(125,0,0,.5);
    }
    .warning .data{
        box-shadow: 0 3px 0 -1px rgba(125,0,0,.5);
    }

    .override-contract .desired,.override-contract .undesired,.override-contract .available,.override-contract .unavailable{
        opacity: .5;
    }

    .handle{
        position: absolute;
        top: 0;
        bottom: 0;
        height: 100%;
        width: 15px;
        margin: auto;
        cursor: col-resize;
        color: #9f9f9f;
        text-align: center;
        transition: .2s;
        opacity: 0;
    }

    .time-bar-new:hover .handle{
        opacity: 1;
    }
    .locked .handle{
        display:none;
    }

    .handle.start{
        left: -10px;

    }

    .handle.end{
        right: -10px;
    }

    .timeframe.selected{
        box-shadow: 0 0 2px 1px rgba(0,170,0,.9);
    }
    .shift .background.tomorrow,.shift .background.yesterday{
        display: none;
    }

    .background.tomorrow,.background.yesterday{
        background: rgba(0,0,0,.1);
        position: absolute;
        height: 100%;
        top: 0;
        bottom: initial;
        margin: 0;
        display: none;
    }

    .fixed .background.tomorrow, .fixed .background.yesterday{
        display: inline-block;
    }

</style>
